import { Link } from "react-router-dom";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import { SpamSearchBox } from "ui";

export type ReportPostsLayoutProps = {
    title: string;
    children: React.ReactNode;
    breadCrumbTitle: string;
};

const ReportPostsLayout = ({
    title,
    children,
    breadCrumbTitle
}: ReportPostsLayoutProps) => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        },
        {
            path: "/report-posts",
            text: "Report Posts"
        }
    ];
    return (
        <section className="w-full h-full flex flex-col relative">
            <div className="w-full h-full flex relative overflow-auto">
                <div className="w-full flex flex-col">
                    <div className="w-full text-center">
                        <div className="flex justify-between items-center w-full text-center px-2">
                            <Link to="/report-posts">
                                <ArrowBackIosNewRoundedIcon
                                    fontSize="small"
                                    className="dark:text-white"
                                />
                            </Link>
                            <Breadcrumb
                                breadcrumb={breadcrumb}
                                currentPath={breadCrumbTitle}
                            />
                        </div>
                        <h1 className="font-medium text-lg dark:text-white py-8">
                            {title}
                        </h1>
                    </div>
                    <SpamSearchBox />
                    <div className="w-full items-center flex flex-col gap-10 px-10 ">
                        {children}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ReportPostsLayout;
